import compose from "recompose/compose";
import optionCallback from "./optionCallback";
import Circle from "./Circle";
import Square from "./Square";
import Star from "./Star";
import Heart from "./Heart";
import Hexagonal from "./Hexagonal";
import Octagon from "./Octagon";
import ScallopedEdge from "./ScallopedEdge ";
import Star_10 from "./Star_10";

export default compose(
	optionCallback('circle', Circle),
	optionCallback('star', Star),
	optionCallback('heart', Heart),
	optionCallback('hexagonal', Hexagonal),
	optionCallback('octagon', Octagon),
	optionCallback('scalloped_edge', ScallopedEdge),
	optionCallback('star_10', Star_10),
	optionCallback('square', Square),
	optionCallback('default', Square) // Default phải để ở cuối
)